import { render, staticRenderFns } from "./SystemSelect.vue?vue&type=template&id=5ac39b1b&scoped=true"
import script from "./SystemSelect.ts?vue&type=script&lang=ts&external"
export * from "./SystemSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./SystemSelect.vue?vue&type=style&index=0&id=5ac39b1b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac39b1b",
  null
  
)

export default component.exports